import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    padding: 16,
  },
  rootDisablePadding: {
    padding: 0,
  },
  icon: {
    color: theme.palette.primary.A400,
  },
});

const SectionBodyEmptyContent = ({ text, icon, disablePadding, classes }) => (
  <div className={classNames(classes.root, {
    [classes.rootDisablePadding]: disablePadding,
  })}>
    <Grid
      container
      spacing={16}
      justify="center"
      alignItems="center"
    >
      {icon && (
        <Grid item>
          <div className={classes.icon}>
            {icon}
          </div>
        </Grid>
      )}
      <Grid item>
        <Typography variant="subheading" color="secondary">
          {text}
        </Typography>
      </Grid>
    </Grid>
  </div>
);

SectionBodyEmptyContent.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.node,
  disablePadding: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
  }).isRequired,
};

SectionBodyEmptyContent.defaultProps = {
  icon: null,
  disablePadding: false,
};

export default withStyles(styles)(SectionBodyEmptyContent);



// WEBPACK FOOTER //
// ./src/components/common/Section/SectionBodyEmptyContent.js